const resetRow = ({ gridRef }) => {
  gridRef?.current?.api?.undoCellEditing();
  gridRef?.current?.api?.startEditingCell({
    rowIndex: gridRef?.current?.api?.getFocusedCell().rowIndex,
    colKey: gridRef?.current?.api?.getFocusedCell().column?.colId,
  });
};

export default resetRow;
